import { z } from 'zod';

/** Shared schema for dual-write SSE events — used by both server and frontend. */
export const DualWriteEventSchema = z.looseObject({
  type: z.enum(['write', 'skip', 'error', 'warning']),
  legacyId: z.number(),
  externalId: z.string().nullable(),
  shape: z.string(),
  blueprintKind: z.string().optional(),
  artifactId: z.string().optional(),
  status: z.enum(['created', 'updated']).optional(),
  error: z.string().optional(),
  errorCode: z.string().optional(),
  errorDetails: z.record(z.string(), z.unknown()).optional(),
  payload: z.record(z.string(), z.unknown()).optional(),
  timestamp: z.string(),
});

export type DualWriteEvent = z.infer<typeof DualWriteEventSchema>;

export const DualWriteEventsResponseSchema = z.object({ events: z.array(DualWriteEventSchema) });
